  import React, { useState } from 'react';
  import TopMenuBar from '../components/TopMenuBar'
  import SignUpNotificationModal from '../components/SignUpNotificationModal';
  import './HomePage.css';
  import recipeIcon from "../../../assets/icons/recipe.png";
  import ingredientIcon from "../../../assets/icons/harvest.png";
  import pollIcon from "../../../assets/icons/ballot.png";
  import shareIcon from "../../../assets/icons/idea.png";

  export const HomePage = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = () => {
      setIsModalOpen(true);
    };

    const handleCloseModal = () => {
      setIsModalOpen(false);
    };

    return (
      <>
      
      <div>
        <section className="banner-section">
        <TopMenuBar />
          <h1>Making meals at home just got easier!</h1>
          <p className="banner-secondary-text">SousPal can help you find recipes based on what you have in the kitchen.</p>
          <button className="signup-button" onClick={handleOpenModal}>Sign up</button>
          <p className="beta-text">Sign up to get notified when we are live and a chance to beta test!</p>
        </section>

        <section className="features-section">
          <div className="feature-column">
            <h2>Homemade meals, hassle-free</h2>
            <p>Get recipes based on what you have, rather than what you need.</p>
            <div className="icon-row">
              <div className="icon"><img height="50px" src={recipeIcon} alt="Recipe Icon" /></div>
            </div>
          </div>
          <div className="feature-column">
            <h2>Track Ingredients</h2>
            <p>Scan in your ingredients and track what's been used and when they expire.</p>
            <div className="icon-row">
              <div className="icon"><img height="50px" src={ingredientIcon} alt="Ingredient Icon" /></div>
            </div>
          </div>
          <div className="feature-column">
            <h2>"What's for dinner?"</h2>
            <p>Avoid this question with the ability to create meal polls and have family members vote on what's for dinner.</p>
            <div className="icon-row">
              <div className="icon"><img height="50px" src={pollIcon} alt="Meal Poll Icon" /></div>
            </div>
          </div>
          <div className="feature-column">
            <h2>Build a community</h2>
            <p>Share recipes to expand the available recipes.</p>
            <div className="icon-row">
              <div className="icon"><img height="50px" src={shareIcon} alt="Share Recipes Icon" /></div>
            </div>
          </div>
        </section>
      </div>

      <SignUpNotificationModal isOpen={isModalOpen} onClose={handleCloseModal} />
      </>
    )
  }
